import { getVesselDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreVesselRepository extends BaseFirestoreRepository {
  async upsertEntity(entity) {
    return this.upsert(
      getVesselDocRef(this.db, entity.id),
      this.addStorageMarker(entity)
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getVesselDocRef(this.db, entityId));
  }
}
